const img = require('./default_org_desktop.png'); export default img;